const DAY_PARTS = ['MORNING', 'AFTERNOON', 'EVENING']

export default DAY_PARTS
